"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const react_1 = require("react");
const CouplingsTable_1 = __importDefault(require("./CouplingsTable"));
const style = {
    borderSpacing: '0',
    width: '100%',
    fontSize: '12px',
    height: '100%',
    margin: '0',
    padding: '0.4rem',
    textAlign: 'center',
};
function SignalFormTab({ onFocus, onBlur }) {
    const { values } = (0, formik_1.useFormikContext)();
    return ((0, jsx_runtime_1.jsx)("div", { style: style, children: (0, jsx_runtime_1.jsx)(formik_1.FieldArray, { name: `signals.${values.activeTab}.js`, render: ({ push, remove }) => ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(CouplingsTable_1.default, { push: push, remove: remove, onFocus: onFocus, onBlur: onBlur }) })) }) }));
}
exports.default = (0, react_1.memo)(SignalFormTab);
